export const deviceMediaQueries = {
  desktop: `@media (min-width: 1024px)`,
  tablet: `@media (max-width: 1023px)`,
  mobile: `@media (max-width: 768px)`,
  extraSmall: `@media (max-width: 360px)`
};

export enum TRACKING_EVENT_NAMES {
  unitTierBox = 'pricing_page_unit_tier_box',
  unitDescriptionTooltipTriggered = 'unit-description-tooltip-triggered',
  billingCycleChanged = 'billing-cycle-changed',
  planCardCTAButtonClicked = 'edition-table-button-clicked',
  unitBreachModalDecision = 'unit-breach-modal-decision',
  unitLimitBreachModal = 'unit-limit-breach-modal',
  userTierTooltipTriggered = 'user-tier-tooltip-triggered',
  showPricingExampleTriggered = 'show-pricing-example-triggered',
  hidePricingExampleTriggered = 'hide-pricing-example-triggered',
  pricingExampleBillingCycleChanged = 'pricing-example-billing-cycle-changed',
  promoCardCTAButtonClicked = 'promo-card-button-clicked'
}

export enum UNIT_TRACKING_TERMS {
  users = 'users',
  agents = 'agents'
}

export const DEFAULT_COUNTRY_ISO_CODE = 'US';
export const DEFAULT_CURRENCY_ISO_CODE = 'USD';

export enum SpecialPlanNames {
  FREE = 'Free',
  STANDARD = 'Standard',
  PREMIUM = 'Premium',
  ENTERPRISE = 'Enterprise'
}

export enum SpecialProductKeys {
  JSM = 'jira-servicedesk.ondemand',
  BITBUCKET = 'com.atlassian.bitbucket.manual'
}

export enum DefaultPlanLimits {
  UNIT_LIMIT_FREE = 10,
  UNIT_LIMIT = 50000,
  UNIT_MIN_ENTERPRISE = 801
}
